


export const routes={

    "home":"/",

    "pageNotFount":"/page-not-found",
    "auth":"/auth",
    "authProcess":"/auth/:pro",

    "logout":"/logout",
    "dashboard":"/dashboard",

    "dashboardRroute":"/dashboard/:route",
    "privacyPolicy":"/privacy-policy",

    "api":{
        "login":"auth/login",
        "generateCode":"auth/generate-code",
        "user":"/user",
        "vehicleAll":"/vehicle/get-all",
        "tripAll":"/trip/get-all",
        "images":"/images",
        "vehicle":"/vehicle",
        "vehicleDocument":"/vehicle-document",
        "pointPackage":"/point-package",
        "pointPackageRequest":"/point-package/request",
        "statistics":{
            "admin":"/statistics/admin"
        },

        "phoneVerification":"/phone-verifications",

        "tripBookings":"/booking/trip/:id",
        
        "paymentAccount":"/payment-account",
        "pricingPolicy":"pricing-policy",
        "map":{
            "pointLocation":"/map/point-location",
            "pointsRoute":"/map/points-route"
        },

    }
}